import { render, staticRenderFns } from "./QualityAverageWidgets.vue?vue&type=template&id=65833836&"
import script from "./QualityAverageWidgets.vue?vue&type=script&lang=js&"
export * from "./QualityAverageWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports